import { AppThunkAction } from "..";
import {
    BreachServiceAndCatalogTypes,
    BreachSummaryTypes,
    RECEIVE_BREACH_SUMMARY,
    RECEIVE_SERVICE_CATALOG,
    REQUEST_BREACH_SUMMARY,
    REQUEST_SERVICE_CATALOG,
} from "./types";
import { getBreachSummary, getServicesAndCatalog } from "../service";
import { breachServiceActive } from "../../util/CommonBreach";
export const actionCreators: any = {
    requestBreachSummary: (): AppThunkAction<BreachSummaryTypes> => (dispatch) => {
        getBreachSummary()
            .then((data) => {
                dispatch({ type: RECEIVE_BREACH_SUMMARY, breachSummaryData: data });
            })
            .catch(function (error) {
                dispatch({ type: RECEIVE_BREACH_SUMMARY, breachSummaryData: null });
            });

        dispatch({ type: REQUEST_BREACH_SUMMARY });
    },
    requestBreachService: (): AppThunkAction<BreachServiceAndCatalogTypes> => (dispatch) => {
        getServicesAndCatalog()
            .then((data) => {
                dispatch({ type: RECEIVE_SERVICE_CATALOG, breachService: data });
                if (breachServiceActive(data)) {
                    dispatch(actionCreators.requestBreachSummary());
                }
            })
            .catch(function (error) {
                dispatch({ type: RECEIVE_SERVICE_CATALOG, breachService: null });
            });

        dispatch({ type: REQUEST_SERVICE_CATALOG });
    },
};
